<script lang="ts">
import { defineComponent } from 'vue'
import CompanyDataService from '@/services/CompanyDataService'
import type Company from '@/types/Company'
import type Address from '@/types/Address'
import type ResponseData from '@/types/ResponseData'
import AddressDataService from '@/services/AddressDataService'
import HeadquartersDataService from '@/services/HeadquartersDataService'
import type Headquarters from '@/types/Headquarters'
import UserDataService from '@/services/UserDataService'
import type User from '@/types/User'
import type ObjectConfig from '@/types/ObjectConfig'
import type SubjectOfBusiness from '@/types/SubjectOfBusiness'
import SubjectOfBusinessDataService from '@/services/SubjectOfBusinessDataService'
import moment from 'moment'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { describeRenewalBillingSource, profileLabel } from '@/utils/renewalBilling'
import type { RenewalBillingInfo } from '@/utils/renewalBilling'

export default defineComponent({
  name: 'company-detail',
  data() {
    return {
      currentCompany: {} as Company,
      currentCompanyAddress: {} as Address,
      currentHeadquarters: {} as Headquarters,
      currentUser: {} as User,
      currentSubjectOfBusiness: {} as SubjectOfBusiness,
      listOfUsers: [] as User[],
      companyStatuses: [] as ObjectConfig[],
      companySubStatuses: [] as ObjectConfig[],
      compantyTypes: [] as ObjectConfig[],
      konecnyUzivateliaVyhod: [] as ObjectConfig[],
      sposobyKonaniaKonatelov: [] as ObjectConfig[],
      headquartersTypes: [] as ObjectConfig[],
      subjectsOfBusiness: [] as SubjectOfBusiness[],
      listOfSubjects: [] as SubjectOfBusiness[],
      newSubjectOfBusiness: {
        title: '',
        price: 0,
        description: '',
        category_id: 0,
        ui_category_id: 0,
      } as SubjectOfBusiness,
      isOpen: false,
      isOpened: false,
      moment: moment(),
      vhqs: [] as any[],
      showStatusInfoModal: false,
      billingProfiles: [] as any[],
      renewalBillingVhq: null as RenewalBillingInfo | null,
      renewalBillingDocuments: null as RenewalBillingInfo | null,
      renewalBillingFailed: false,
      showBillingProfileModal: false,
      isSavingBillingProfile: false,
      editingBillingProfileId: null as number | null,
      editingBillingAddressId: null as number | null,
      billingProfileTarget: 'vhq' as 'vhq' | 'documents',
      newBillingProfile: {
        name: '',
        first_name: '',
        last_name: '',
        ico: '',
        dic: '',
        ic_dph: '',
      },
      newBillingAddress: {
        street: '',
        street_number: '',
        city: '',
        psc: '',
        country: 'Slovensko',
      }
    }
  },
  methods: {
    updateHeadquarters() {

      const addressPictureMap = {
        'Ružinovská': 'https://bizinix.sk/src/assets/ruzinovska.png',
        'Panorama towers': 'https://bizinix.sk/src/assets/panorama.png',
        'Klingerka': 'https://bizinix.sk/src/assets/klingerka.png',
        'Miletička': 'https://bizinix.sk/src/assets/mileticova.png',
        'SKY PARK Residence': 'https://bizinix.sk/src/assets/skyparkn.png',
        'Eurovea Tower': 'https://bizinix.sk/src/assets/virtualne-sidlo-eurovea-tower.jpeg',
      };

      this.currentHeadquarters.img = addressPictureMap[this.currentHeadquarters.owner_name];

      HeadquartersDataService.update(this.currentHeadquarters.id, { owner_name: this.currentHeadquarters.owner_name, img: addressPictureMap[this.currentHeadquarters.owner_name] })
        .then(() => {
          toast.success('Owner name updated successfully.');
        })
        .catch((e: Error) => {
          toast.error('Failed to update owner name: ' + e.message);
        });
    },
    getAllUsers() {
      UserDataService.getAllUsers("all")
        .then((response: ResponseData) => {
          this.listOfUsers = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getAllVhqs() {
      HeadquartersDataService.getAllVirtualHeadquarters()
        .then((response: ResponseData) => {
          this.vhqs = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompanyStatuses() {
      CompanyDataService.getCompanyStatuses()
        .then((response: ResponseData) => {
          this.companyStatuses = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompanySubStatuses() {
      CompanyDataService.getCompanySubStatuses()
        .then((response: ResponseData) => {
          this.companySubStatuses = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompanyTypes() {
      CompanyDataService.getCompanyTypes()
        .then((response: ResponseData) => {
          this.compantyTypes = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getKonecnyUzivateliaVyhod() {
      CompanyDataService.getKonecnyUzivateliaVyhod()
        .then((response: ResponseData) => {
          this.konecnyUzivateliaVyhod = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getHeadquartersTypes() {
      HeadquartersDataService.getHeadquartersTypes()
        .then((response: ResponseData) => {
          this.headquartersTypes = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getSposobyKonaniaKonatelov() {
      CompanyDataService.getSposobyKonaniaKonatelov()
        .then((response: ResponseData) => {
          this.sposobyKonaniaKonatelov = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getUser(id: any) {
      UserDataService.getUserById(id)
        .then((response: ResponseData) => {
          this.currentUser = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompanyAddress(id: any) {
      AddressDataService.getAddressById(id)
        .then((response: ResponseData) => {
          this.currentCompanyAddress = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompanyHeadquarters(id: any) {
      HeadquartersDataService.getHeadquartersById(id)
        .then((response: ResponseData) => {
          this.currentHeadquarters = response.data.data
          this.getCompanyAddress(this.currentHeadquarters.address_id)
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getCompany(id: any) {
      CompanyDataService.getCompanyById(id)
        .then((response: ResponseData) => {
          this.currentCompany = response.data.data
          this.currentCompany.vhq_renewal_fakturacne_udaje_id =
            this.currentCompany.vhq_renewal_fakturacne_udaje_id ?? null
          this.currentCompany.documents_renewal_fakturacne_udaje_id =
            this.currentCompany.documents_renewal_fakturacne_udaje_id ?? null
          this.getCompanyHeadquarters(this.currentCompany.headquarters_id)
          this.getUser(this.currentCompany.owner)
          this.subjectsOfBusiness = JSON.parse(this.currentCompany.subjects_of_business)
          this.loadBillingProfiles()
          this.loadRenewalBillingInfo()
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    loadBillingProfiles() {
      if (!this.currentCompany.owner) return
      UserDataService.getFakturacneUdajeByUserId(this.currentCompany.owner)
        .then((response: ResponseData) => {
          this.billingProfiles = response.data.data ?? []
        })
        .catch((e: Error) => {
          toast.error('Chyba pri načítaní fakturačných profilov: ' + e.message)
        })
    },
    loadRenewalBillingInfo() {
      this.renewalBillingFailed = false
      CompanyDataService.getRenewalBillingProfile(this.currentCompany.id, 'vhq')
        .then((response: ResponseData) => {
          this.renewalBillingVhq = response.data.data
        })
        .catch(() => {
          this.renewalBillingVhq = null
          this.renewalBillingFailed = true
        })
      CompanyDataService.getRenewalBillingProfile(this.currentCompany.id, 'documents')
        .then((response: ResponseData) => {
          this.renewalBillingDocuments = response.data.data
        })
        .catch(() => {
          this.renewalBillingDocuments = null
          this.renewalBillingFailed = true
        })
    },
    renewalBillingText(which: 'vhq' | 'documents') {
      if (this.renewalBillingFailed) return 'Info nedostupné (BE ešte nemusí mať nasadený endpoint)'
      return describeRenewalBillingSource(which === 'vhq' ? this.renewalBillingVhq : this.renewalBillingDocuments)
    },
    billingProfileLabel(profile: any) {
      return profileLabel(profile)
    },
    openNewBillingProfile(target: 'vhq' | 'documents') {
      this.billingProfileTarget = target
      this.isSavingBillingProfile = false
      this.editingBillingProfileId = null
      this.editingBillingAddressId = null
      this.newBillingProfile = { name: '', first_name: '', last_name: '', ico: '', dic: '', ic_dph: '' }
      this.newBillingAddress = { street: '', street_number: '', city: '', psc: '', country: 'Slovensko' }
      this.showBillingProfileModal = true
    },
    openEditBillingProfile(target: 'vhq' | 'documents') {
      const overrideId = target === 'vhq'
        ? this.currentCompany.vhq_renewal_fakturacne_udaje_id
        : this.currentCompany.documents_renewal_fakturacne_udaje_id
      if (!overrideId) {
        toast.error('Najprv v dropdowne vyberte profil, ktorý chcete upraviť.')
        return
      }
      this.billingProfileTarget = target
      this.isSavingBillingProfile = false
      this.editingBillingProfileId = overrideId
      const known = this.billingProfiles.find((p: any) => p.id === overrideId)
      const applyProfile = (profile: any) => {
        this.newBillingProfile = {
          name: profile.name ?? '',
          first_name: profile.first_name ?? '',
          last_name: profile.last_name ?? '',
          ico: profile.ico ?? '',
          dic: profile.dic ?? '',
          ic_dph: profile.ic_dph ?? '',
        }
        this.editingBillingAddressId = profile.address_id ?? null
        if (profile.address_id) {
          AddressDataService.getAddressById(profile.address_id)
            .then((response: ResponseData) => {
              const a = response.data.data ?? {}
              this.newBillingAddress = {
                street: a.street ?? '',
                street_number: a.street_number ?? '',
                city: a.city ?? '',
                psc: a.psc ?? '',
                country: a.country ?? 'Slovensko',
              }
            })
            .catch((e: Error) => {
              toast.error('Chyba pri načítaní adresy profilu: ' + e.message)
            })
        }
        this.showBillingProfileModal = true
      }
      if (known) {
        applyProfile(known)
      } else {
        UserDataService.getFakturacneUdajeById(overrideId)
          .then((response: ResponseData) => applyProfile(response.data.data))
          .catch((e: Error) => {
            toast.error('Chyba pri načítaní profilu: ' + e.message)
          })
      }
    },
    createBillingProfile() {
      if (this.isSavingBillingProfile) return
      this.isSavingBillingProfile = true
      if (this.editingBillingProfileId) {
        const addressId = this.editingBillingAddressId
        const updateAddress = addressId
          ? AddressDataService.update(addressId, this.newBillingAddress)
          : Promise.resolve(null)
        updateAddress
          .then(() => UserDataService.updateFakturacneUdaje(this.editingBillingProfileId, {
            ...this.newBillingProfile,
            user_id: this.currentCompany.owner,
            address_id: addressId,
          }))
          .then(() => UserDataService.getFakturacneUdajeByUserId(this.currentCompany.owner))
          .then((response: ResponseData) => {
            this.billingProfiles = response.data.data ?? []
            this.loadRenewalBillingInfo()
            this.showBillingProfileModal = false
            toast.success('Fakturačný profil upravený.')
          })
          .catch((e: Error) => {
            toast.error('Chyba pri úprave profilu: ' + e.message)
          })
          .finally(() => {
            this.isSavingBillingProfile = false
          })
        return
      }
      AddressDataService.add(this.newBillingAddress)
        .then((addressResponse: ResponseData) => {
          const addressId = addressResponse.data.address_id ?? addressResponse.data.id
          return UserDataService.addFakturacneUdaje({
            ...this.newBillingProfile,
            user_id: this.currentCompany.owner,
            address_id: addressId,
          })
        })
        .then((profileResponse: ResponseData) => {
          const newId = profileResponse.data.id
          return UserDataService.getFakturacneUdajeByUserId(this.currentCompany.owner)
            .then((response: ResponseData) => {
              this.billingProfiles = response.data.data ?? []
              if (this.billingProfileTarget === 'vhq') {
                this.currentCompany.vhq_renewal_fakturacne_udaje_id = newId
              } else {
                this.currentCompany.documents_renewal_fakturacne_udaje_id = newId
              }
              this.showBillingProfileModal = false
              toast.success('Fakturačný profil pridaný a predvybraný. Nezabudnite dať Uložiť.')
            })
        })
        .catch((e: Error) => {
          toast.error('Chyba pri pridaní profilu: ' + e.message)
        })
        .finally(() => {
          this.isSavingBillingProfile = false
        })
    },
    getAllSubjectsOfBusiness() {
      SubjectOfBusinessDataService.getAllSubjectsOfBusiness()
        .then((response: ResponseData) => {
          this.listOfSubjects = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getSubjectOfBusiness(id: any) {
      SubjectOfBusinessDataService.getSubjectOfBusinessById(id)
        .then((response: ResponseData) => {
          this.newSubjectOfBusiness = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    updateCompany() {
      CompanyDataService.update(this.currentCompany.id, this.currentCompany)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava spoločností' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    updateCompanyAddress() {
      AddressDataService.update(this.currentHeadquarters.address_id, this.currentCompanyAddress)
        .then((response: ResponseData) => {
          this.updateCompanyHeadquarters();
          toast.success('Adresa sídla úspešne zmenená.');
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })

    },
    updateCompanyHeadquarters() {
      HeadquartersDataService.update(this.currentHeadquarters.id, this.currentHeadquarters)
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    deleteCompany() {
      CompanyDataService.delete(this.currentCompany.id)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava spoločností' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    deleteSob(id: any) {
      const index = this.subjectsOfBusiness.findIndex(obj => obj.id === id)
      if (index > -1) {
        this.subjectsOfBusiness.splice(index, 1)
      }
      this.currentCompany.subjects_of_business = JSON.stringify(this.subjectsOfBusiness)
      CompanyDataService.update(this.currentCompany.id, this.currentCompany)
        .then((response: ResponseData) => {
          this.isOpen = false
          this.$router.push({ name: 'Úprava spoločností' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    uploadImage(evt: any) {
      this.currentHeadquarters.img = evt.target.files[0].name
      HeadquartersDataService.uploadImage(this.currentHeadquarters.id, evt.target.files[0])
        .then((response: ResponseData) => {
          this.currentHeadquarters.img = evt.target.files[0].name
          this.$emit('imageUrl', response.data.secure_url)
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    onChange(event: any) {
      this.currentCompany.owner = event.target.value
    },
    onSubjectChange(event: any) {
      this.getSubjectOfBusiness(event.target.value)
    },
    onVhqChange(event: any) {
      this.getCompanyAddress(event.target.value)
    },
    onIsVirtualChange(event: any) {
      if (event.target.value == false) {
        this.getCompanyHeadquarters(this.currentCompany.headquarters_id)
      }
    },
    updateSubjectOfBusinessForCompany() {
      // Ensure ui_category_id is present in all subjects
      this.subjectsOfBusiness = this.subjectsOfBusiness.map(sbj => ({
        ...sbj,
        ui_category_id: sbj.ui_category_id ?? 0
      }));
      this.currentCompany.subjects_of_business = JSON.stringify(this.subjectsOfBusiness)
      CompanyDataService.update(this.currentCompany.id, this.currentCompany)
        .then(() => {
          this.$router.push({ name: 'Úprava spoločností' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    addSubjectOfBusinessForCompany() {
      if (this.subjectsOfBusiness == null) {
        this.subjectsOfBusiness = [] as SubjectOfBusiness[]
      }
      // Ensure ui_category_id is present
      if (!('ui_category_id' in this.newSubjectOfBusiness)) {
        this.newSubjectOfBusiness.ui_category_id = 0;
      }
      this.subjectsOfBusiness.push({ ...this.newSubjectOfBusiness });
      this.currentCompany.subjects_of_business = JSON.stringify(this.subjectsOfBusiness)
      CompanyDataService.update(this.currentCompany.id, this.currentCompany)
        .then(() => {
          this.isOpen = false
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    sendNotification(message: any) {
      const data = {
        email: this.currentUser.email,
        message: message,
      }
      UserDataService.sendNotification(data)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava klientov' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  mounted() {
    this.getAllUsers()
    this.getCompanyStatuses()
    this.getCompanySubStatuses()
    this.getCompanyTypes()
    this.getKonecnyUzivateliaVyhod()
    this.getSposobyKonaniaKonatelov()
    this.getHeadquartersTypes()
    this.getAllVhqs()
    this.getAllSubjectsOfBusiness()
    this.getCompany(this.$route.params.id)
  },
})
</script>

<template>
  <main>
    <div class="flex flex-row justify-between max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-6">
      <div class="basis-1/4">
        <button @click="goBack" type="button"
          class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          Späť
        </button>
      </div>
      <div class="basis-1/4">
        <h1 class="text-2xl font-semibold text-gray-900">Detail spoločnosti - {{ currentCompany.id }}</h1>
      </div>
      <div class="basis-1/4">
        <button @click="isOpened = true" type="button"
          class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
          Zmazať
        </button>
      </div>
    </div>
    <div v-show="isOpened" id="alert-dialog"
      class="p-4 mb-4 border border-red-300 rounded-lg bg-red-50 dark:bg-red-200 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-6"
      role="alert">
      <div class="flex items-center">
        <svg aria-hidden="true" class="w-5 h-5 mr-2 text-red-900 dark:text-red-800" fill="currentColor"
          viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"></path>
        </svg>
        <span class="sr-only">Info</span>
        <h3 class="text-lg font-medium text-red-900 dark:text-red-800">Zmazanie záznamu z databázy</h3>
      </div>
      <div class="mt-2 mb-4 text-sm text-red-900 dark:text-red-800">
        Naozaj chcete zmazať tento záznam z databázy? Je to nenávratné :(
      </div>
      <div class="flex">
        <button type="button"
          class="text-white bg-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 mr-2 text-center inline-flex items-center dark:bg-red-800 dark:hover:bg-red-900"
          @click="deleteCompany()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>

          Zmazať
        </button>
        <button type="button"
          class="text-red-900 bg-transparent border border-red-900 hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 text-center dark:border-red-800 dark:text-red-800 dark:hover:text-white"
          data-dismiss-target="#alert-additional-content-2" aria-label="Close" @click="isOpened = false">
          Zrušiť
        </button>
      </div>
    </div>
    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="flex gap-6">

            <div class="mt-5 md:mt-0 flex flex-col basis-2/3">
              <div class="flex flex-col mb-5">
                <label for="note" class="block text-sm font-medium text-gray-700">Poznámka</label>
                <FormKit type="text" v-model="currentCompany.note" name="note" id="note"
                  class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
              </div>
              <div class="pb-6">
                <h3 class="text-2xl font-bold leading-6 text-gray-900">Informácie o spoločnosti</h3>
              </div>
              <form @submit.prevent="updateCompany">
                <div class="shadow overflow-hidden rounded-md">
                  <div class="px-4 py-5 bg-white">
                    <div class="flex flex-row gap-6 pb-6">
                      <div class="flex flex-col basis-1/2 gap-2">
                        <div class="flex flex-col">
                          <label for="name" class="block text-sm font-medium text-gray-700">Názov spoločnosti</label>
                          <FormKit type="text" v-model="currentCompany.name" name="name" id="name"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="dic" class="block text-sm font-medium text-gray-700">DIČ</label>
                          <FormKit type="text" v-model="currentCompany.dic" name="dic" id="dic"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="registration_date" class="block text-sm font-medium text-gray-700">Začiatok
                            oprávnenia</label>
                          <FormKit type="text" v-model="currentCompany.zaciatok_opravnenia" name="registration_date"
                            id="registration_date"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="imanie_splatene" class="block text-sm font-medium text-gray-700">Splatené
                            ímanie</label>
                          <FormKit type="text" number v-model="currentCompany.imanie_splatene" name="imanie_splatene"
                            id="imanie_splatene"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="is_dph" class="block text-sm font-medium text-gray-700 pr-2">Je platiteľ
                            DPH?</label>
                          <input id="is_dph" v-model="currentCompany.is_dph" :checked="currentCompany.is_dph"
                            type="checkbox"
                            class="w-4 h-4 focus:ring-teal-500 focus:border-teal-500 block shadow-sm sm:text-sm border-gray-300 rounded-md text-teal-500" />
                        </div>

                        <div class="flex flex-col">
                          <label for="hide_from_ui" class="block text-sm font-medium text-gray-700 pr-2">Skryť zo UI (hide_from_ui)</label>
                          <input id="hide_from_ui" v-model="currentCompany.hide_from_ui" :checked="currentCompany.hide_from_ui ?? false"
                            type="checkbox"
                            class="w-4 h-4 focus:ring-teal-500 focus:border-teal-500 block shadow-sm sm:text-sm border-gray-300 rounded-md text-teal-500" />
                        </div>
                      </div>

                      <div class="flex flex-col basis-1/2 gap-2">
                        <div class="flex flex-col">
                          <label for="ico" class="block text-sm font-medium text-gray-700">IČO</label>
                          <FormKit type="text" v-model="currentCompany.ico" name="ico" id="ico"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="icdhp" class="block text-sm font-medium text-gray-700">IČDPH</label>
                          <FormKit type="text" v-model="currentCompany.icdph" name="icdhp" id="icdhp"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="imanie_vyska" class="block text-sm font-medium text-gray-700">Základné
                            ímanie</label>
                          <FormKit type="text" number v-model="currentCompany.imanie_vyska" name="imanie_vyska"
                            id="imanie_vyska"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="owner">Účet spoločnosti (správca)</label>
                          <select id="owner" v-model="currentCompany.owner" @change="onChange($event)"
                            class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm">
                            <option v-if="!listOfUsers?.length">Žiadny klienti sa nenašli</option>
                            <option v-for="user in listOfUsers" :key="user.id"
                              v-bind:selected="currentCompany.owner == currentUser.id" :value="user.id">
                              {{ user.first_name }} {{ user.last_name }}, {{ user.email }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-row gap-6">
                      <div class="flex flex-col basis-1/2">
                        <div class="flex flex-col">
                          <label for="sposob_konania_konatelov" class="block text-sm font-medium text-gray-700">Spôsob
                            konania konateľov</label>
                          <select v-model="currentCompany.sposob_konania_konatelov" name="sposob_konania_konatelov"
                            id="sposob_konania_konatelov"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option v-for="sposob in sposobyKonaniaKonatelov" :key="sposob.id" :value="sposob.id">
                              {{ sposob.name }} ({{ sposob.id }})
                            </option>
                          </select>
                        </div>

                        <div class="flex flex-col">
                          <label for="skk_details" class="block text-sm font-medium text-gray-700">Spôsob konania
                            konateľov - detaily</label>
                          <FormKit type="text" v-model="currentCompany.skk_details" name="skk_details" id="skk_details"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="konecny_uzivatelia_vyhod" class="block text-sm font-medium text-gray-700">Konečný
                            užívatelia výhod</label>
                          <select v-model="currentCompany.konecny_uzivatelia_vyhod" name="konecny_uzivatelia_vyhod"
                            id="konecny_uzivatelia_vyhod"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option v-for="kuv in konecnyUzivateliaVyhod" :key="kuv.id" :value="kuv.id">
                              {{ kuv.name }} ({{ kuv.id }})
                            </option>
                          </select>
                        </div>

                        <div class="flex flex-col">
                          <label for="kuv_details" class="block text-sm font-medium text-gray-700">Konečný užívatelia
                            výhod - detaily</label>
                          <FormKit type="text" v-model="currentCompany.kuv_details" name="kuv_details" id="kuv_details"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                      <div class="flex flex-col basis-1/2">
                        <div class="flex flex-col">
                          <label for="type" class="block text-sm font-medium text-gray-700">Typ spoločnosti</label>
                          <select v-model="currentCompany.type" name="type" id="type"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option v-for="companyType in compantyTypes" :key="companyType.id" :value="companyType.id">
                              {{ companyType.name }} ({{ companyType.id }})
                            </option>
                          </select>
                        </div>

                        <div class="flex flex-col">
                          <label for="status" class="block text-sm font-medium text-gray-700">Stav spoločnosti</label>
                          <select v-model="currentCompany.status" name="status" id="status"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option v-for="status in companyStatuses" :key="status.id" :value="status.id">
                              {{ status.name }} ({{ status.id }})
                            </option>
                          </select>
                        </div>

                        <div class="flex flex-col">
                          <div class="flex items-center space-x-1">
                            <label for="sub_status" class="block text-sm font-medium text-gray-700">Stav
                              žiadosti</label>
                            <button type="button" @click="showStatusInfoModal = true"
                              class="cursor-pointer text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full inline-flex items-center justify-center w-5 h-5 text-xs font-bold transition-colors duration-200">?</button>
                          </div>
                          <select v-model="currentCompany.sub_status" name="sub_status" id="sub_status"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option v-for="subStatus in companySubStatuses" :key="subStatus.id" :value="subStatus.id">
                              {{ subStatus.name }} ({{ subStatus.id }})
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="px-4 py-3 bg-gray-50 text-right">
                    <button type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                      Uložiť
                    </button>
                  </div>
                </div>
              </form>

              <div class="flex flex-col py-6">
                <div class="px-4 sm:px-0">
                  <h3 class="text-2xl font-bold leading-6 text-gray-900">Adresa</h3>
                </div>
              </div>

              <div class="flex flex-row w-fit">
                <input id="is_virtual" v-model="currentHeadquarters.is_virtual"
                  :checked="currentHeadquarters.is_virtual" type="checkbox" @change="onIsVirtualChange($event)"
                  :value="currentHeadquarters.is_virtual"
                  class="w-4 h-4 focus:ring-teal-500 focus:border-teal-500 block shadow-sm sm:text-sm border-gray-300 rounded-md text-teal-500" />
                <label for="is_virtual" class="block text-sm font-medium text-gray-700 pl-2">Naše virtuálne
                  sídlo</label>
              </div>

              <div v-if="currentHeadquarters.is_virtual" class="flex flex-col py-2 px-6">
                <select id="vhqs" name="vhqs" @change="onVhqChange($event)">
                  <option :value="currentHeadquarters.address_id">Vyberte Virtuálne sídlo</option>
                  <option v-for="vhq in vhqs" :key="vhq.address_id" :value="vhq.address_id"
                    :selected="vhq.address_id == currentHeadquarters.address_id" class="text-black">{{ vhq.name }}
                  </option>
                </select>
              </div>

              <div class="px-4 py-6 sm:px-0">
                <div class="mt-10 sm:mt-0">
                  <div class="flex flex-col gap-6">
                    <div class="mt-5 md:mt-0 flex flex-col">
                      <form @submit.prevent="updateCompanyAddress">
                        <div class="shadow overflow-hidden sm:rounded-md">
                          <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="flex flex-row gap-6">
                              <div class="flex flex-col basis-1/2">
                                <div class="flex flex-col">
                                  <label for="city" class="block text-sm font-medium text-gray-700">Mesto</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.city" name="city" id="city"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>

                                <div class="flex flex-col">
                                  <label for="street_number" class="block text-sm font-medium text-gray-700">Súpisné
                                    číslo</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.street_number"
                                    name="street_number" id="street_number"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>

                                <div class="flex flex-col">
                                  <label for="psc" class="block text-sm font-medium text-gray-700">PSČ</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.psc" name="psc" id="psc"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>
                              </div>

                              <div class="flex flex-col basis-1/2">
                                <div class="flex flex-col">
                                  <label for="street" class="block text-sm font-medium text-gray-700">Ulica</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.street" name="street" id="street"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>

                                <div class="flex flex-col">
                                  <label for="street_number2" class="block text-sm font-medium text-gray-700">Orientačné
                                    číslo</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.street_number2"
                                    name="street_number2" id="street_number2"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>
                                <div class="flex flex-col">
                                  <label for="country" class="block text-sm font-medium text-gray-700">Krajina</label>
                                  <FormKit type="text" v-model="currentCompanyAddress.country" name="country"
                                    id="country"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button type="submit"
                              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                              Uložiť
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="py-5">
        <div class="border-t border-gray-200"></div>
      </div>

      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="flex flex-col pb-3">
            <h3 class="text-4xl font-bold leading-6 text-gray-900 text-center">Služby</h3>
          </div>
          <div class="flex flex-row gap-6">
            <div class="flex flex-col">
              <div class="flex flex-col basis-1/3">
                <div class="px-4 sm:px-0">
                  <div class="pb-6">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Legenda</h3>
                  </div>
                  <p>Typy:</p>
                  <div class="overflow-hidden border rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col"
                            class="flex items-center px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase">
                            ID
                          </th>
                          <th scope="col" class="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase">
                            <span class="inline-flex items-center"> Názov </span>
                          </th>
                          <th scope="col" class="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase">
                            <span class="inline-flex items-center"> Popis </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200">
                        <tr v-for="hqType in headquartersTypes" :key="hqType.id">
                          <td class="px-6 py-4 text-sm font-medium text-gray-800">
                            {{ hqType.id }}
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-800">{{ hqType.name }}</td>
                          <td class="px-6 py-4 text-sm text-gray-800">
                            {{ hqType.description }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col">

              <div class="px-4 py-6 sm:px-0">
                <div class="mt-10 sm:mt-0">
                  <div class="flex flex-col gap-6">
                    <div class="mt-5 md:mt-0 flex flex-col">
                      <form @submit.prevent="updateCompany">
                        <div class="shadow overflow-hidden sm:rounded-md">
                          <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="flex flex-col gap-6">
                              <div class="flex flex-row justify-between">
                                <div class="flex flex-col">
                                  <div class="px-4 sm:px-0">
                                    <h3 class="text-lg font-bold leading-6 text-gray-900">Fakturácia</h3>
                                  </div>
                                </div>
                                <div class="flex flex-col">
                                  <FormKit type="text" name="fa_request" id="fa_request" placeholder="Posledný request"
                                    class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>
                              </div>
                              <div class="flex flex-row justify-between">
                                <div class="flex flex-col">
                                  <label for="zaplatene" class="block text-sm font-medium text-gray-700">Balík zaplatený
                                    do:</label>
                                  <FormKit type="text" v-model="currentCompany.fakturacia_zaplatene_do" name="zaplatene"
                                    id="zaplatene" class="mt-1 block w-full shadow-sm sm:text-sm rounded-md" :class="[
                                      moment.isSame(currentCompany.fakturacia_zaplatene_do, 'day') ||
                                        moment.isAfter(currentCompany.fakturacia_zaplatene_do, 'day')
                                        ? 'border-red-500 focus:ring-red-600 focus:border-red-600'
                                        : 'border-gray-300 focus:ring-teal-500 focus:border-teal-500',
                                    ]" />
                                  <div class="py-2" v-if="
                                    moment.isSame(currentCompany.fakturacia_zaplatene_do, 'day') ||
                                    moment.isAfter(currentCompany.fakturacia_zaplatene_do, 'day')
                                  ">
                                    <button type="button"
                                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                                      @click="sendNotification('Platnosť Vášho balíka pre Fakturáciu vypršala. Zakúpte si predĺženie už dnes a získajte mnoho výhod! :)')">
                                      Odoslať notifickáciu
                                    </button>
                                  </div>
                                </div>
                                <div v-if="currentCompany.fakturacia_free" class="font-bold mt-6 text-xl">
                                  !! Trial balík je aktívny !!
                                </div>
                              </div>
                              <div class="flex flex-row gap-4 pt-2">
                                <div class="flex flex-col">
                                  <label for="documents_renewal_profile"
                                    class="block text-sm font-medium text-gray-700">Fakturačný profil pre
                                    auto-obnovu Dokladov</label>
                                  <select id="documents_renewal_profile" name="documents_renewal_profile"
                                    v-model="currentCompany.documents_renewal_fakturacne_udaje_id">
                                    <option :value="null">Predvolené (posledná uhradená objednávka)</option>
                                    <option v-for="profile in billingProfiles" :key="profile.id" :value="profile.id">
                                      {{ billingProfileLabel(profile) }}
                                    </option>
                                  </select>
                                  <p class="mt-1 text-sm text-gray-500">{{ renewalBillingText('documents') }}</p>
                                </div>
                                <div class="flex flex-col justify-end">
                                  <button type="button"
                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                              @click="openNewBillingProfile('documents')">
                              Pridať nový profil
                            </button>
                            <button type="button"
                              class="inline-flex justify-center py-2 px-4 mt-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                              @click="openEditBillingProfile('documents')">
                              Upraviť vybraný
                            </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button type="submit"
                              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                              Uložiť
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-10 md:mt-0">
                <div class="shadow overflow-hidden sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6">
                    <div class="flex flex-col pb-4">
                      <label for="owner_name" class="block text-xl font-bold text-gray-700">Virtuálne sídlo</label>
                    </div>
                    <div class="flex flex-col gap-6">
                      <p>Aktualne sídlo: <b>{{ currentHeadquarters.owner_name }}</b></p>
                      <select id="owner_name" name="owner_name" v-model="currentHeadquarters.owner_name"
                        @change="updateHeadquarters">
                        <option value="">Vyber sídlo</option>
                        <option value="Ružinovská">Ružinovská</option>
                        <option value="Panorama towers">Panorama towers</option>
                        <option value="Klingerka">Klingerka</option>
                        <option value="Miletička">Miletička</option>
                        <option value="SKY PARK Residence">SKY PARK Residence</option>
                        <option value="Eurovea Tower">Eurovea Tower</option>
                      </select>

                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 md:mt-0">
                <form @submit.prevent="updateCompany">
                  <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                      <div class="flex flex-col pb-4">
                        <label for="name" class="block text-xl font-bold text-gray-700">Virtuálne sídlo a pošta</label>
                      </div>
                      <div class="flex flex-col gap-6">
                        <div class="flex flex-row gap-4">
                          <div class="flex flex-col">
                            <label for="sidlo_typ_balika" class="block text-sm font-medium text-gray-700">Balík</label>
                            <select id="sidlo_typ_balika" name="sidlo_typ_balika"
                              v-model="currentCompany.sidlo_typ_balika">
                              <option value=""></option>
                              <option value="Mini">Mini</option>
                              <option value="Ideal">Ideal</option>
                              <option value="Premium">Premium</option>
                              <option value="Extra">Extra</option>
                              <option value="Individual">Individual</option>
                              <option value="Základný trvalý pobyt v Bratislave">Základný trvalý pobyt v Bratislave</option>
                              <option value="Najlepší trvalý pobyt v Bratislave">Najlepší trvalý pobyt v Bratislave</option>
                            </select>
                          </div>
                          <div class="flex flex-col">
                            <label for="price" class="block text-sm font-medium text-gray-700">Cena</label>
                            <FormKit type="text" number v-model="currentHeadquarters.price" name="price" id="price"
                              class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                          </div>
                          <div class="flex flex-col justify-end">
                            <FormKit type="text" name="vs_request" id="vs_request" placeholder="Posledný request"
                              class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                          </div>

                        </div>
                        <div class="flex flex-row">
                          <div class="flex flex-col">
                            <label for="zaplatene" class="block text-sm font-medium text-gray-700">Balík zaplatený
                              do:</label>
                            <FormKit type="text" v-model="currentCompany.sidlo_zaplatene_do" name="zaplatene"
                              id="zaplatene" class="mt-1 block w-full shadow-sm sm:text-sm rounded-md" :class="[
                                moment.isSame(currentCompany.sidlo_zaplatene_do, 'day') ||
                                  moment.isAfter(currentCompany.sidlo_zaplatene_do, 'day')
                                  ? 'border-red-500 focus:ring-red-600 focus:border-red-600'
                                  : 'border-gray-300 focus:ring-teal-500 focus:border-teal-500',
                              ]" />
                            <div class="py-2" v-if="
                              moment.isSame(currentCompany.sidlo_zaplatene_do, 'day') ||
                              moment.isAfter(currentCompany.sidlo_zaplatene_do, 'day')
                            ">
                              <button type="button"
                                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                                @click="sendNotification('Platnosť Vášho balíka pre Virutálne sídlo vypršala. Zakúpte si predĺženie už dnes a získajte mnoho výhod! :)')">
                                Odoslať notifickáciu
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-row gap-4">
                          <div class="flex flex-col">
                            <label for="vhq_renewal_profile"
                              class="block text-sm font-medium text-gray-700">Fakturačný profil pre auto-obnovu
                              sídla</label>
                            <select id="vhq_renewal_profile" name="vhq_renewal_profile"
                              v-model="currentCompany.vhq_renewal_fakturacne_udaje_id">
                              <option :value="null">Predvolené (posledná uhradená objednávka)</option>
                              <option v-for="profile in billingProfiles" :key="profile.id" :value="profile.id">
                                {{ billingProfileLabel(profile) }}
                              </option>
                            </select>
                            <p class="mt-1 text-sm text-gray-500">{{ renewalBillingText('vhq') }}</p>
                          </div>
                          <div class="flex flex-col justify-end">
                            <button type="button"
                              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                              @click="openNewBillingProfile('vhq')">
                              Pridať nový profil
                            </button>
                            <button type="button"
                              class="inline-flex justify-center py-2 px-4 mt-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                              @click="openEditBillingProfile('vhq')">
                              Upraviť vybraný
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                      <button type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        Uložiť
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="px-4 py-6 sm:px-0">
        <div class="py-5">
          <div class="border-t border-gray-200"></div>
        </div>
        <div class="mt-10 sm:mt-0">
          <div class="flex flex-col gap-6">
            <div class="flex flex-col">
              <div class="px-4 sm:px-0">
                <div class="flex flex-row justify-between">
                  <h3 class="text-lg font-medium leading-6 text-gray-900">Predmety podnikania</h3>
                  <div>
                    <button type="button" @click="isOpen = true"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                      Pridať nový predmet
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main modal -->
            <div v-show="isOpen" id="sob-modal" tabindex="-1"
              class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
              <div class="relative p-4 w-full max-w-md h-full md:h-auto">
                <!-- Modal content -->
                <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                  <button type="button"
                    class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white">
                    <svg @click="isOpen = false" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"></path>
                    </svg>
                    <span class="sr-only">Close modal</span>
                  </button>
                  <div class="mt-5 md:mt-0 flex flex-col">
                    <div class="shadow">
                      <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="flex">
                          <div class="mt-1">
                            <label for="listOfSubjects">Predmety podnikania</label>
                            <select id="listOfSubjects" v-model="newSubjectOfBusiness.id"
                              @change="onSubjectChange($event)"
                              class="block w-full border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm">
                              <option v-if="!listOfSubjects.length">Žiadne predmety sa nenašli</option>
                              <option v-else v-for="subject in listOfSubjects" :key="subject.id"
                                v-bind:value="subject.id">
                                {{ subject.title }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <form @submit.prevent="addSubjectOfBusinessForCompany()">
                      <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white sm:p-6">
                          <div class="flex flex-row gap-6">
                            <div class="flex flex-col">
                              <label for="title" class="block text-sm font-medium text-gray-700">Názov</label>
                              <FormKit type="text" v-model="newSubjectOfBusiness.title" name="title" id="title"
                                class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>

                            <div class="flex flex-col">
                              <label for="description" class="block text-sm font-medium text-gray-700">Popis</label>
                              <FormKit type="text" v-model="newSubjectOfBusiness.description" name="description"
                                id="description"
                                class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>

                            <div class="flex flex-col">
                              <label for="price" class="block text-sm font-medium text-gray-700">Cena</label>
                              <FormKit type="text" number v-model="newSubjectOfBusiness.price" name="price" id="price"
                                class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>

                            <div class="flex flex-col">
                              <label for="category_id" class="block text-sm font-medium text-gray-700">Kategória</label>
                              <FormKit type="text" number v-model="newSubjectOfBusiness.category_id" name="category_id"
                                id="category_id"
                                class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                            <div class="flex flex-col">
                              <label for="ui_category_id" class="block text-sm font-medium text-gray-700">UI
                                Kategória</label>
                              <FormKit type="text" number v-model="newSubjectOfBusiness.ui_category_id as any"
                                name="ui_category_id" id="ui_category_id"
                                class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-row px-4 py-3 justify-between bg-gray-50 text-right sm:px-6">
                          <button @click="isOpen = false" type="button"
                            class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                            Zrušiť
                          </button>

                          <button type="submit"
                            class="focus:outline-none text-white bg-teal-600 hover:bg-teal-700 focus:ring-4 focus:ring-teal-500 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2">
                            Uložiť
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isOpen" class="opacity-25 fixed inset-0 z-40 bg-black"></div>

            <!-- New billing profile modal -->
            <div v-show="showBillingProfileModal" id="billing-profile-modal" tabindex="-1"
              class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
              <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
                <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                  <div class="px-4 py-5 sm:p-6">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ editingBillingProfileId ? 'Upraviť fakturačný profil' : 'Nový fakturačný profil' }}</h3>
                    <div class="flex flex-col gap-4 pt-4">
                      <div class="flex flex-row gap-4">
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Meno / Názov</label>
                          <FormKit type="text" v-model="newBillingProfile.name" name="bp_name"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                      <div class="flex flex-row gap-4">
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Meno</label>
                          <FormKit type="text" v-model="newBillingProfile.first_name" name="bp_first_name"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Priezvisko</label>
                          <FormKit type="text" v-model="newBillingProfile.last_name" name="bp_last_name"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                      <div class="flex flex-row gap-4">
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">IČO</label>
                          <FormKit type="text" v-model="newBillingProfile.ico" name="bp_ico"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">DIČ</label>
                          <FormKit type="text" v-model="newBillingProfile.dic" name="bp_dic"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">IČ DPH</label>
                          <FormKit type="text" v-model="newBillingProfile.ic_dph" name="bp_ic_dph"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                      <div class="flex flex-row gap-4">
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Ulica *</label>
                          <FormKit type="text" v-model="newBillingAddress.street" name="bp_street"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Číslo</label>
                          <FormKit type="text" v-model="newBillingAddress.street_number" name="bp_street_number"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                      <div class="flex flex-row gap-4">
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Mesto *</label>
                          <FormKit type="text" v-model="newBillingAddress.city" name="bp_city"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">PSČ *</label>
                          <FormKit type="text" v-model="newBillingAddress.psc" name="bp_psc"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col w-full min-w-0">
                          <label class="block text-sm font-medium text-gray-700">Krajina *</label>
                          <FormKit type="text" v-model="newBillingAddress.country" name="bp_country"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-row px-4 py-3 justify-between bg-gray-50 text-right sm:px-6">
                    <button @click="showBillingProfileModal = false" type="button"
                      class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                      Zrušiť
                    </button>
                    <button @click="createBillingProfile" type="button" :disabled="isSavingBillingProfile"
                      class="focus:outline-none text-white bg-teal-600 hover:bg-teal-700 focus:ring-4 focus:ring-teal-500 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2">
                      {{ editingBillingProfileId ? 'Uložiť zmeny' : 'Uložiť profil' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="showBillingProfileModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>

            <div v-if="subjectsOfBusiness" class="mt-5 md:mt-0 flex flex-col py-2">
              <div v-for="subjectOfBusiness in subjectsOfBusiness" :key="subjectOfBusiness.id"
                class="mt-5 md:mt-0 flex flex-col py-2">
                <form @submit.prevent="updateSubjectOfBusinessForCompany()">
                  <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                      <div class="flex flex-row gap-6">
                        <div class="flex flex-col">
                          <label for="title" class="block text-sm font-medium text-gray-700">Názov</label>
                          <FormKit type="text" v-model="subjectOfBusiness.title" name="title" id="title"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="description" class="block text-sm font-medium text-gray-700">Popis</label>
                          <FormKit type="text" v-model="subjectOfBusiness.description" name="description"
                            id="description"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="price" class="block text-sm font-medium text-gray-700">Cena</label>
                          <FormKit type="text" number v-model="subjectOfBusiness.price" name="price" id="price"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>

                        <div class="flex flex-col">
                          <label for="category_id" class="block text-sm font-medium text-gray-700">Kategória</label>
                          <FormKit type="text" number v-model="subjectOfBusiness.category_id" name="category_id"
                            id="category_id"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                        <div class="flex flex-col">
                          <label for="ui_category_id" class="block text-sm font-medium text-gray-700">UI
                            Kategória</label>
                          <FormKit type="text" number v-model="subjectOfBusiness.ui_category_id as any"
                            name="ui_category_id" id="ui_category_id"
                            class="mt-1 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                        </div>
                      </div>
                    </div>
                    <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                      <button @click="deleteSob(subjectOfBusiness.id)" type="button"
                        class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                        Zmazať
                      </button>
                      <button type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        Uložiť
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- Status Info Modal -->
  <div v-if="showStatusInfoModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
    aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- Background overlay -->
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"
        @click="showStatusInfoModal = false"></div>

      <!-- Modal panel -->
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                Popis stavov žiadosti
              </h3>
              <div class="mt-4 max-h-96 overflow-y-auto pr-2">
                <div v-for="subStatus in companySubStatuses" :key="subStatus.id"
                  class="mb-4 pb-4 border-b border-gray-200 last:border-b-0 last:mb-0 last:pb-0">
                  <div class="font-medium text-gray-900 mb-1">{{ subStatus.name }} ({{ subStatus.id }})</div>
                  <div class="text-gray-600">{{ subStatus.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            @click="showStatusInfoModal = false">
            Zavrieť
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
